/**
 * @file 已完成案件弹窗内容组件
 * @description 案件状态为已完成时显示，包含案件基本信息、图片轮播、查看详情按钮
 */
<template>
    <div class="case-dialog-content-done">
        <div class="case-name">
            {{ caseDialogObj.name }}
        </div>
        <div class="case-status" v-if="caseDialogObj.status !== undefined && caseDialogObj.status !== null">
            <span :class="['status-tag', getStatusClass(caseDialogObj.status)]">{{caseDialogObj.statusLabel }}</span>
        </div>
        <div class="case-detail-row">
            <span class="label">{{  $t('yingji.emergencyCase.caseLevel') }}</span>
            <span class="value">{{ caseDialogObj.levelLabel }}</span>
        </div>
        <div class="case-detail-row">
            <span class="label">{{  $t('yingji.emergencyCase.caseDesc')  }}</span>
            <span class="value text-break">{{ caseDialogObj.content }}</span>
        </div>
        <div class="case-detail-row">
            <span class="label label-address">{{  $t('yingji.emergencyCase.incidentLocation')  }}</span>
            <span class="value">{{ caseDialogObj.location }}</span>
        </div>
        <div class="case-image-carousel" v-if="caseDialogObj.imageVideoList && caseDialogObj.imageVideoList.length > 0">
            <el-carousel height="200px" indicator-position="bottom" arrow="hover">
                <el-carousel-item v-for="(item, index) in caseDialogObj.imageVideoList" :key="index">
                    <div class="carousel-item-content" :class="{ 'is-video': item.type === 'video' }">
                        <el-image v-if="!item.type || item.type === 'image'" :src="item.pathUrl" fit="contain" alt=""></el-image>
                        <video v-if="item.type === 'video'" :src="item.pathUrl" controls></video>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="case-footer-buttons">
            <el-button class="dialog-btn-cancel" @click="handleCloseDialog">{{  $t('common.btnCancel') }}</el-button>
            <el-button class="dialog-btn-detail" type="primary" @click="goToDetail">{{  $t('yingji.emergencyCase.viewDetail') }}</el-button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'EmergencyCaseDone',
    props: {
        caseDialogObj: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters(['userInfo']),
    },
    watch: {
        caseDialogObj: {
            handler(newVal) {
                console.log('caseDialogObj', newVal);
            },
            deep: true,
        },
    },
    methods: {
        getStatusClass(status) {
            const classMap = {
                0: 'status-pending',
                1: 'status-processing',
                2: 'status-done',
            };
            return classMap[status] || 'status-pending';
        },
        goToDetail() {
            this.$emit('close');
            this.$router.push({
                path: `/yingji/detail/${this.caseDialogObj.id}`,
            });
        },
        handleCloseDialog() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.case-dialog-content-done {
    .case-name {
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        line-height: 1.4;
        margin-bottom: 5px;
        max-width: 500px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .case-status {
        margin-bottom: 5px;
        .status-tag {
            display: inline-block;
            padding: 2px 12px;
            border-radius: 2px;
            font-size: 12px;
            font-weight: normal;
            color: #fff;

            &.status-pending {
                background: rgba(73, 240, 253, 0.2);
                color: #49f0fd;
            }

            &.status-processing {
                background: rgba(255, 152, 0, 0.2);
                color: #ff9800;
            }

            &.status-done {
                background: rgba(0, 255, 136, 0.2);
                color: #00ff88;
            }
        }
    }

    .case-detail-row {
        display: flex;
        align-items: flex-start;
        line-height: 28px;

        .label {
            width: 65px;
            font-size: 16px;
            color: rgba(255, 255, 255, 0.8);
            text-align: justify;
            text-align-last: justify;
        }

        .value {
            flex: 1;
            padding-left: 20px;
            font-size: 16px;
            color: #fff;
            line-height: 1.5;

            &.text-break {
                white-space: normal;
                word-break: break-word;
                overflow: visible;
                text-overflow: clip;
            }
        }
    }

    .case-image-carousel {
        margin-top: 15px;
        border-radius: 2px;
        overflow: hidden;

        ::v-deep .el-carousel__container {
            height: 200px;
        }

        ::v-deep .el-carousel__item {
            height: 100%;
        }

        ::v-deep .el-carousel__indicators {
            .el-carousel__indicator {
                button {
                    background-color: rgba(255, 255, 255, 0.3);
                }
                &.is-active button {
                    background-color: #49f0fd;
                }
            }
        }

        .carousel-item-content {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 200px;

            &:not(.is-video) {
                background: #fff;
            }

            &.is-video {
                background: #000;
            }

            .el-image {
                width: 100%;
                height: 100%;
            }

            .el-image ::v-deep .el-image__inner {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
            }

            video {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
            }
        }
    }

    .case-footer-buttons {
        display: flex;
        justify-content: flex-end;
        gap: 15px;
        margin-top: 15px;
        padding-bottom: 5px;

        .dialog-btn-cancel {
            flex: 0 0 80px;
            height: 30px;
            line-height: 12px;
            font-size: 16px;
            background: rgba(255, 255, 255, 0.15);
            border: 1px solid rgba(255, 255, 255, 0.3);
            color: #fff;
            border-radius: 4px;

            &:hover {
                background: rgba(255, 255, 255, 0.25);
                border-color: rgba(255, 255, 255, 0.5);
            }
        }

        .dialog-btn-detail {
            flex: 0 0 80px;
            height: 30px;
            line-height: 12px;
            font-size: 16px;
            background: rgba(73, 240, 253, 0.25);
            border: 1px solid #49f0fd;
            color: #49f0fd;
            border-radius: 4px;

            &:hover {
                background: rgba(73, 240, 253, 0.4);
            }
        }
    }
}
</style>
